/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownBeneficiaryStatus } from '../models/db_DropdownBeneficiaryStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BeneficiaryStatuses {
    /**
     * Get a list of beneficiary statuses
     * @returns db_DropdownBeneficiaryStatus OK
     * @throws ApiError
     */
    public static listBeneficiaryStatuses(): CancelablePromise<Array<db_DropdownBeneficiaryStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiary-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
